const SYSTEMS = {
  systemattribute: 'Systemattribut|Systemattribute',
  systemgroup: 'Systemgruppe|Systemgruppen',
  system: 'System|Systeme',
  system_advantage: 'Systemvorteil|Systemvorteile',
};

export default SYSTEMS;
